import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain" }
const _hoisted_2 = { style: {"background":"rgba(0, 108, 144, 0.65)"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10 foot" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fw-bold fs-6" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/media/misc/CondicionesGeneralesOC.pdf",
      target: "_blank",
      class: "text-muted text-hover-primary px-2"
    }, "Políticas de uso"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/media/misc/CondicionesGeneralesOC.pdf",
      target: "_blank",
      class: "text-muted text-hover-primary px-2"
    }, "Términos y Condiciones")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Licitaciones = _resolveComponent("Licitaciones")!
  const _component_Noticias = _resolveComponent("Noticias")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex-center flex-column flex-column-fluid",
      style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.getIllustrationsPath('fondo-melon-1.jpg') + ')', backgroundSize: 'cover'  })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ])
    ], 4),
    (_ctx.mostrar)
      ? (_openBlock(), _createBlock(_component_Licitaciones, {
          key: 0,
          onMostrarLicitaciones: _ctx.mostrarLicitaciones
        }, null, 8, ["onMostrarLicitaciones"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Noticias),
    _hoisted_3
  ]))
}